<template>
  <div class="c-header__user-menu">
      <div class="c-header__item-user--ico"><span class="c-header__item-user--ico-name">{{ fullUserName }}</span></div>
      <ul>
        <li class="c-header__item-user has-subitems">
          <span class="c-header__item-user--user-name">{{ $t('nav.hello', { name: fullUserName } )}}</span>
          <ul class="c-header__sublist">
              <li class="c-header__sublist--item"><router-link :to="{name: 'experiments'}">{{ $t('nav.experiments')}}</router-link></li>
              <li class="c-header__sublist--item"><router-link :to="{name: 'configuration'}">{{ $t('nav.configuration')}}</router-link></li>
              <li class="c-header__sublist--item" v-on:click="logout">{{ $t('landing.logout') }}</li>
          </ul>
        </li>
      </ul>
  </div>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'UserMenu',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullUserName() {
      return [this.user.name, this.user.firstname]
        .filter((v) => v !== null)
        .join(' ')
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('security/logout')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
